import { Alert } from '@zillow/constellation-10';
import accessUtils from '../../utils/accessUtils';

type ReimportSyncingBannerProps = {
  isReimportInProgress?: boolean;
};

/**
 * Shown while a feed re-import triggered by a recent edit is settling. Editing is paused for the whole
 * listing until listing-tools finishes re-exporting it (or the lock's TTL elapses).
 */
const ReimportSyncingBanner = ({ isReimportInProgress = false }: ReimportSyncingBannerProps) => {
  if (!isReimportInProgress || !accessUtils.canAccessFeedOverrides()) {
    return null;
  }

  return (
    <Alert tone="info" css={{ marginBottom: '600' }}>
      Syncing with the feed. Editing is paused while your latest changes are applied to this listing. This usually takes
      a few minutes.
    </Alert>
  );
};

export default ReimportSyncingBanner;
